export enum TargetGroup {
    Turkana = 1,
    Refugee = 2,
    Lake_Community = 3,
    Other = 4
}

export const targetGroups = Object.values(TargetGroup).filter((v) => !isNaN(Number(v))) as number[];